import PropTypes from 'prop-types';
import React from 'react';

import RichText, { domToReact } from '@/components/RichText/RichText';
import StrapiImage from '@/components/StrapiImage/StrapiImage';

import PersonInfo from './PersonInfo';
import {
  Content,
  MainPhoto,
  Quote,
  TileText,
  Wrapper,
} from './StandardTile.style';

const richTextReplacer = (element, wrappedReplacer) => {
  if (element.name === 'p' && element.children.length) {
    return (
      <TileText variant="body1">
        {domToReact(element.children, { replace: wrappedReplacer })}
      </TileText>
    );
  }

  return null;
};

const StandardTile = ({ image, content, logo, personName, companyName }) => {
  return (
    <Wrapper data-test-subject="standard-testimonial-tile">
      <MainPhoto>
        <StrapiImage data={image} fill sizes="120px" />
      </MainPhoto>
      <Quote />
      <Content>
        <RichText data={content} replace={richTextReplacer} />
      </Content>
      <PersonInfo {...{ logo, personName, companyName }} />
    </Wrapper>
  );
};

StandardTile.propTypes = {
  content: PropTypes.string.isRequired,
  /** Image. */
  image: PropTypes.object,
  /** Company logo. */
  logo: PropTypes.object,
  /** Person name */
  personName: PropTypes.string,
  /** Person role in company */
  companyName: PropTypes.string.isRequired,
};

StandardTile.defaultProps = {
  image: null,
  logo: '',
  personName: '',
};

export default StandardTile;
